import {Injectable} from '@angular/core';
import {LorenBaseEndpointsService} from '../../../loren-base-endpoints-service/loren-base-endpoints.service';

@Injectable({
    providedIn: 'root'
})
export class LorenLayerEndpointsService extends LorenBaseEndpointsService {

    constructor() {
        super();
    }

    getLayers() {
        return `${this.getApiServerUrl()}/layers`;
    }

    getLayerItems(layerId: number, neLat: number, neLng: number, seLat: number, seLng: number, zoomLevel: number) {
        return `${this.getApiServerUrl()}/layers/${layerId}/items?viewport_nw_lat=${neLat}&viewport_nw_lng=${neLng}&viewport_se_lat=${seLat}&viewport_se_lng=${seLng}&zoom_level=${zoomLevel}`;
    }
}
